import { render, staticRenderFns } from "./animation-edit.vue?vue&type=template&id=12d9c15e&scoped=true"
import script from "./animation-edit.vue?vue&type=script&lang=js"
export * from "./animation-edit.vue?vue&type=script&lang=js"
import style0 from "./animation-edit.vue?vue&type=style&index=0&id=12d9c15e&prod&lang=scss&scoped=true"
import style1 from "./animation-edit.vue?vue&type=style&index=1&id=12d9c15e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9c15e",
  null
  
)

export default component.exports